module.exports = __webpack_public_path__ + "media/assets/icons/location-pin-grey-4bfebbfd448d88b6661ac58bc9c6a261.svg";